'use strict';

const { grecaptchaGenerateToken } = require('./common/grecaptchaUtils');

$(document).ready(() => {
    const $appointmentForm = $('.appointment-form');
    const $modal = $('#book-appointment-modal');

    /**
   * Resets the book appointment modal to its initial state.
   * @function
   */
    function resetAppointmentModalToInitialState() {
        $('.appointment-call-scheduler').addClass('d-none').hide();
        $('.appointment-first-section').show();
        $('.appointment-confirm-call-schedule').addClass('d-none').hide();
        $('#appointment-available-time-field').val('');
        $('#appointment-selected-date-field').val('');
        $('.appointment-available-time-options ul').empty();
        $('#appointmentDatesContainer').empty();
        $('#appointmentTimeSlotDropdown').empty();
        $('.appointment-date.selected').removeClass('selected');
        $('.appointment-available-time-options').hide();
        $('.appointment-available-time-dropdown').removeClass('rotate');

        $('#appointmentStateDropdown').val('').removeClass('has-value');
        $('#appointmentStoreDropdown').val('').removeClass('has-value');
        $('.appointment-state-values').addClass('d-none').removeClass('show');
        $('.appointment-store-values').addClass('d-none').removeClass('show');
        $('.appointment-dropdown').removeClass('open');
        $('.appointment-store-dropdown').removeClass('open');
        $('.py-dropdown-icon').removeClass('rotate');
        $('.appointment-store-icon').removeClass('rotate');

        $('.appointment-state-values .py-option-value').removeClass('selected');
        $('.appointment-store-values .py-option-value').removeClass('selected');
        $('.appointment-store-values ul').empty();

        $('.appointment-call-scheduler-btn').prop('disabled', true).addClass('disabled');
    }

    /**
   * Validates form fields and enables/disables submit button.
   * @function
   */
    function validateFormFields() {
        const stateSelected = $('#appointmentStateDropdown').val() && $('#appointmentStateDropdown').val().trim() !== '';
        const storeSelected = $('#appointmentStoreDropdown').val() && $('#appointmentStoreDropdown').val().trim() !== '';
        const $submitBtn = $('.appointment-call-scheduler-btn');

        if (stateSelected && storeSelected) {
            $submitBtn.prop('disabled', false).removeClass('disabled');
        } else {
            $submitBtn.prop('disabled', true).addClass('disabled');
        }
    }

    /**
   * Populates store dropdown with <li> elements based on the response from backend.
   * @param {Object} response - The response object containing store details.
   * @param {boolean} response.success - Indicates if the response is successful.
   * @param {Array} response.storesDetails - Array of store objects.
   * @param {Object} response.storesDetails[].storeData - Object containing store information.
   * @param {string|number} response.storesDetails[].storeData.id - Store ID.
   * @param {string} response.storesDetails[].storeData.name - Store name.
   * @param {string} response.storesDetails[].storeData.city - Store city.
   * @function
   */
    function populateStoreDropdown(response) {
        const $storeUl = $('.appointment-store-values ul');
        $storeUl.empty();

        if (response.success && response.storesDetails && response.storesDetails.length) {
            response.storesDetails.forEach((store) => {
                const storeInfo = store.storeData;

                if (storeInfo && storeInfo.id && storeInfo.name && storeInfo.city) {
                    const $li = $('<li></li>')
                        .addClass('py-option-value appointment-store-value')
                        .data('value', storeInfo.id)
                        .val(storeInfo.id)
                        .attr('tabindex', '-1')
                        .text(`${storeInfo.name}-${storeInfo.city}`);

                    $li.on('click', function () {
                        const selectedStoreId = $(this).data('value');
                        const displayText = $(this).text();
                        $('.appointment-store-values .py-option-value').removeClass('selected');
                        $(this).addClass('selected');
                        $('#appointmentStoreDropdown').val(displayText);
                        $('#selectedStoreId').val(selectedStoreId);
                        if (selectedStoreId && selectedStoreId.toString().trim() !== '') {
                            $('#appointmentStoreDropdown').addClass('has-value');
                        } else {
                            $('#appointmentStoreDropdown').removeClass('has-value');
                        }

                        $('.appointment-store-values').addClass('d-none').removeClass('show');
                        $('.appointment-store-dropdown').removeClass('open');
                        $('.appointment-store-icon').removeClass('rotate');
                        validateFormFields();
                    });

                    $storeUl.append($li);
                }
            });
        } else {
            $storeUl.html('<li class="no-stores-option">No stores available</li>');
        }
    }

    /**
   * Formats a Date object into a 12-hour time string (e.g., "02:30 PM").
   * @param {Date} date - The Date object to format.
   * @returns {string} A string representing the formatted 12-hour time.
   * @function
   */
    function formatTime(date) {
        return date
            .toLocaleTimeString('en-IN', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            })
            .toUpperCase();
    }

    /**
     * Rounds a Date up to the next 15-minute boundary.
     * If the date is already exactly on a 15-minute boundary, returns the same time.
     * @param {Date} date - The date to round up.
     * @returns {Date} - The rounded date.
     */
    function roundUpToNextQuarter(date) {
        const dateObj = new Date(date);
        dateObj.setSeconds(0, 0);
        const minutes = dateObj.getMinutes();
        const rem = minutes % 15;
        if (rem === 0) return dateObj;
        dateObj.setMinutes(minutes + (15 - rem));
        return dateObj;
    }

    /**
   * Populates time slots in both the dropdown and native select.
   * @function
   */
    function populateAppointmentCustomTimeSlots() {
        const ul = $('.appointment-available-time-options ul');
        const nativeSelect = $('#appointmentTimeSlotDropdown');
        const inputField = $('#appointment-available-time-field');
        const dropdown = $('.appointment-available-time-options');
        const arrow = $('#appointment-salutation-dropdown');
        ul.empty();
        nativeSelect.empty();

        // Use selected date if present; else today
        const selectedDateVal = $('#appointment-selected-date-field').val();
        const baseDate = selectedDateVal ? new Date(selectedDateVal + 'T00:00:00') : new Date();

        const start = new Date(baseDate);
        start.setHours(10, 0, 0, 0);
        const endLimit = new Date(baseDate);
        endLimit.setHours(19, 0, 0, 0);

        const todayISO = new Date().toISOString().split('T')[0];
        const isToday = selectedDateVal ? (selectedDateVal === todayISO) : (start.toISOString().split('T')[0] === todayISO);
        const now = new Date();
        const minStartForToday = isToday ? roundUpToNextQuarter(now) : null;
        const forceSelectFirst = selectedDateVal && !isToday;
        if (forceSelectFirst) {
            inputField.val('');
        }

        let firstSlotSet = false;

        while (start < endLimit) {
            const end = new Date(start.getTime() + 15 * 60000);
            const slotText = `${formatTime(start)} - ${formatTime(end)}`;

            const option = $('<option></option>').val(slotText).text(slotText);
            let disabled = false;
            if (isToday && minStartForToday) {
                const slotStart = new Date(start.getTime());
                if (slotStart < minStartForToday) disabled = true;
            }

            if (disabled) {
                option.addClass('d-none');
            }

            nativeSelect.append(option);
            const li = $('<li tabindex="-1" class="appointment-available-time-option"></li>')
                .attr('data-value', slotText)
                .html(`<span>${slotText}</span>`);

            if (disabled) li.addClass('d-none');

            if (inputField.val() === slotText) {
                if (disabled) {
                    inputField.val('');
                } else {
                    li.addClass('selected');
                    option.prop('selected', true);
                }
            }

            // Pick first non-disabled slot as default, or force-first for non-today
            if ((!firstSlotSet && !inputField.val() && !disabled) || (!firstSlotSet && forceSelectFirst && !disabled)) {
                inputField.val(slotText);
                li.addClass('selected');
                option.prop('selected', true);
                firstSlotSet = true;
            }

            li.on('click', (e) => {
                e.stopPropagation();
                if (li.hasClass('disabled')) return;
                ul.find('li.selected').removeClass('selected');
                li.addClass('selected');
                inputField.val(slotText);
                nativeSelect.val(slotText);
                dropdown.hide();
                arrow.removeClass('rotate');
            });

            ul.append(li);
            start.setTime(end.getTime());
        }
    }

    /**
   * Formats a date string into a short, human-readable format (e.g., "Mon, Jun 10").
   * @param {string} dateString - A date string in ISO or recognizable format.
   * @returns {string} A formatted date string for display.
   * @function
   */
    function formatDisplayDate(dateString) {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            weekday: 'short',
            month: 'short',
            day: 'numeric'
        });
    }

    /**
   * Initializes the date scheduler (carousel).
   * @function
   */
    function initAppointmentScheduler() {
        const datesContainer = document.getElementById('appointmentDatesContainer');
        if (!datesContainer) return;

        const today = new Date();
        const now = new Date();
        const todayEndLimit = new Date(today);
        todayEndLimit.setHours(19, 0, 0, 0);
        const roundedNow = roundUpToNextQuarter(now);
        const skipToday = roundedNow >= todayEndLimit;

        datesContainer.innerHTML = '';
        for (let offset = 0; offset < 14; offset += 1) {
            const date = new Date(today);
            date.setDate(today.getDate() + offset + (skipToday ? 1 : 0));
            const btn = document.createElement('div');
            btn.className = 'appointment-date';
            btn.innerHTML = `
                <div class="initial">${date.toLocaleDateString('en-US', { weekday: 'short' }).charAt(0)}</div>
                <div class="date-number">${date.getDate()}</div>
                <div class="initial">${date.toLocaleDateString('en-US', { month: 'short' })}</div>
            `;
            btn.dataset.date = date.toISOString().split('T')[0];
            btn.onclick = () => {
                document.querySelectorAll('.appointment-date').forEach((el) => el.classList.remove('selected'));
                btn.classList.add('selected');
                $('#appointment-selected-date-field').val(btn.dataset.date);
                populateAppointmentCustomTimeSlots();
            };

            // Select the first available date (which will be tomorrow when skipping today)
            if (offset === 0) {
                btn.classList.add('selected');
                $('#appointment-selected-date-field').val(btn.dataset.date);
                populateAppointmentCustomTimeSlots();
            }

            datesContainer.appendChild(btn);
        }

        const navLeft = document.querySelector('.appointment-nav-left');
        const navRight = document.querySelector('.appointment-nav-right');

        if (navLeft && navRight) {
            navLeft.onclick = () => datesContainer.scrollBy({ left: -100, behavior: 'smooth' });
            navRight.onclick = () => datesContainer.scrollBy({ left: 100, behavior: 'smooth' });
        }
    }

    const timeZoneEl = document.getElementById('appointment-time-zone-display');
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    try {
        const offset = new Date()
            .toLocaleTimeString('en-US', {
                timeZone: userTimeZone,
                timeZoneName: 'short'
            })
            .split(' ')
            .pop();

        if (timeZoneEl) {
            timeZoneEl.textContent = `${userTimeZone.replace('_', ' ')} (${offset})`;
        }
    } catch (e) {
        if (timeZoneEl) timeZoneEl.textContent = 'Unknown';
    }

    const controllerURL = $('#appointmentStoresURL').val();

    const $stateInput = $('#appointmentStateDropdown');
    const $stateDropdown = $('.appointment-state-values');
    const $stateIcon = $('.appointment-state-icon');
    const $stateWrapper = $('.appointment-dropdown');
    const $storeInput = $('#appointmentStoreDropdown');
    const $storeDropdown = $('.appointment-store-values');
    const $storeIcon = $('.appointment-store-icon');
    const $storeWrapper = $('.appointment-store-dropdown');

    $modal.on('hidden.bs.modal', () => {
        resetAppointmentModalToInitialState();
    });

    $('.close, .appointment-continue-shopping-btn').on('click', (e) => {
        e.preventDefault();
        $modal.modal('hide');
    });

    $('.appointment-content').on('click', (e) => {
        e.stopPropagation();
    });

    $stateInput.add($stateIcon).on('click', (e) => {
        e.stopPropagation();

        $storeDropdown.addClass('d-none').removeClass('show');
        $storeWrapper.removeClass('open');
        $storeIcon.removeClass('rotate');

        const isOpen = $stateDropdown.hasClass('show');
        if (isOpen) {
            $stateDropdown.addClass('d-none').removeClass('show');
            $stateWrapper.removeClass('open');
            $stateIcon.removeClass('rotate');
        } else {
            $stateDropdown.removeClass('d-none').addClass('show');
            $stateWrapper.addClass('open');
            $stateIcon.addClass('rotate');
        }
    });

    $storeInput.add($storeIcon).on('click', (e) => {
        e.stopPropagation();
        $stateDropdown.addClass('d-none').removeClass('show');
        $stateWrapper.removeClass('open');
        $stateIcon.removeClass('rotate');

        const isOpen = $storeDropdown.hasClass('show');
        if (isOpen) {
            $storeDropdown.addClass('d-none').removeClass('show');
            $storeWrapper.removeClass('open');
            $storeIcon.removeClass('rotate');
        } else {
            $storeDropdown.removeClass('d-none').addClass('show');
            $storeWrapper.addClass('open');
            $storeIcon.addClass('rotate');
        }
    });

    $stateDropdown.find('.py-option-value').on('click', function () {
        const selectedValue = $(this).data('value');
        const selectedText = $(this).text();
        $stateDropdown.find('.py-option-value').removeClass('selected');
        $(this).addClass('selected');
        $stateInput.val(selectedText).attr('data-value', selectedValue);
        if (selectedValue && selectedValue.trim() !== '') {
            $stateInput.addClass('has-value');
        } else {
            $stateInput.removeClass('has-value');
        }

        $stateDropdown.addClass('d-none').removeClass('show');
        $stateWrapper.removeClass('open');
        $stateIcon.removeClass('rotate');

        $storeInput.val('').removeClass('has-value');
        $('.appointment-store-values ul').html('<li class="loading-option">Loading stores...</li>');
        validateFormFields();

        if (controllerURL) {
            $.ajax({
                url: controllerURL,
                method: 'GET',
                dataType: 'json',
                data: {
                    stateCode: selectedValue
                },
                success: (response) => {
                    populateStoreDropdown(response);
                    validateFormFields();
                },
                error: () => {
                    $('.appointment-store-values ul').html('<li class="error-option">Error loading stores</li>');
                }
            });
        }
    });

    $(document).on('click', (e) => {
        if (!$(e.target).closest('.appointment-dropdown, .appointment-store-dropdown').length) {
            $stateDropdown.addClass('d-none').removeClass('show');
            $stateWrapper.removeClass('open');
            $stateIcon.removeClass('rotate');

            $storeDropdown.addClass('d-none').removeClass('show');
            $storeWrapper.removeClass('open');
            $storeIcon.removeClass('rotate');
        }
    });

    if (($stateInput.val() || '').trim() !== '') $stateInput.addClass('has-value');
    if (($storeInput.val() || '').trim() !== '') $storeInput.addClass('has-value');

    $stateInput.on('blur', function () {
        if (($(this).val() || '').trim() === '') {
            $(this).removeClass('has-value');
        }
    });

    $storeInput.on('blur', function () {
        if (($(this).val() || '').trim() === '') {
            $(this).removeClass('has-value');
        }
    });

    $('.appointment-first-section-btn').on('click', (e) => {
        e.preventDefault();
        $('.appointment-first-section').hide();
        $('.appointment-call-scheduler').removeClass('d-none').show();
        initAppointmentScheduler();
        validateFormFields();
    });

    const appointmentContainer = $('.appointment-available-select-div');
    const appointmentDropdown = $('.appointment-available-time-options');
    const appointmentArrow = $('#appointment-salutation-dropdown');

    appointmentContainer.on('click', (e) => {
        e.stopPropagation();
        $('.appointment-available-time-options').not(appointmentDropdown).hide();
        $('.appointment-available-time-dropdown').not(appointmentArrow).removeClass('rotate');
        appointmentDropdown.toggle();
        appointmentArrow.toggleClass('rotate', appointmentDropdown.is(':visible'));
    });

    $(document).on('click', () => {
        if (appointmentDropdown.is(':visible')) {
            appointmentDropdown.hide();
            appointmentArrow.removeClass('rotate');
        }
    });

    /**
   * AJAX submit appointment form.
   * @function
   */
    $appointmentForm.on('submit', async function (e) {
        e.preventDefault();

        const stateSelected = $('#appointmentStateDropdown').val() && $('#appointmentStateDropdown').val().trim() !== '';
        const storeSelected = $('#appointmentStoreDropdown').val() && $('#appointmentStoreDropdown').val().trim() !== '';

        if (!stateSelected || !storeSelected) {
            return;
        }
        const formData = $(this).serialize() + '&recaptchaToken=' + await grecaptchaGenerateToken();
        $('.appointment-call-scheduler-btn').prop('disabled', true).addClass('disabled');

        $.ajax({
            url: $appointmentForm.attr('action'),
            method: 'POST',
            data: formData,
            success: (response) => {
                $('.appointment-call-scheduler').addClass('d-none').hide();
                const displayDate = formatDisplayDate(response.formData.date);
                const displayTime = response.formData.timeSlot;
                const finalDisplay = `${displayDate} | ${displayTime}`;
                $('.appointment-scheduled-date-time').text(finalDisplay);
                $('.appointment-confirm-call-schedule').removeClass('d-none').show();
            },
            complete: () => {
                validateFormFields();
            }
        });
    });

    $('.appointment-call-scheduler-btn').on('click', (e) => {
        e.preventDefault();
        if (!$(e.target).prop('disabled')) {
            $appointmentForm.submit();
        }
    });

    validateFormFields();
});
